import LayoutCarouselStatic from './LayoutCarouselStatic';

export default LayoutCarouselStatic;
